var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-box"},[(_vm.List.length > 0)?_c('InformList',{attrs:{"list2":_vm.List,"page":_vm.page},on:{"sizeChange":_vm.sizeChange,"currentChange":_vm.currentChange}}):_vm._e(),_vm._v(" "),(_vm.List.length <= 0)?_c('empty',{staticClass:"empty-margin"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74ec6fcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PersonalCenter/components/MessageCenter.vue
// module id = null
// module chunks = 